import Slider from '@mui/material/Slider';
import React from 'react';
const Range = (props) => {

    return (
        <div className="ca-control">
            <label htmlFor={props.id} className="form-label">{props.title}</label>
            <Slider
                id={props.id}
                name={props.id}
                defaultValue={props.value ? props.value : 0}
                onChange={props.onChange}
                step={1}
                min={props.min}
                max={props.max}
                disabled={props.readOnly}
                required={props.required}
                valueLabelDisplay="on"
            />
            <div className='d-flex justify-content-between calculators-range__container'>
                <span className="calculators-range__container--text">{props.min}</span>
                <span className="calculators-range__container--text">{props.max}</span>
            </div>
        </div>
    )
}


export default Range;